// extracted by mini-css-extract-plugin
export default {"container":"two-factor-secrets_container__ddno6","amount":"two-factor-secrets_amount__oPeuJ"};